import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class SemesterService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
     private _getSemesterAllUrl = APIURL+'Semester/getAllSemester';
    private _getSemesterUrl = APIURL+'Semester/Semester';
    private _isActivelUrl = APIURL+'Semester/SemesterVerify';
    private _deleteUrl = APIURL+'Semester/deleteSemester';
    private _addUrl = APIURL+'Semester/saveSemester';
    private _getSemesterBySubUrl = APIURL+'Semester/SemesterBySubUrl';
    private _getSemesterByIdUrl = APIURL+'Semester/SemesterByIdUrl';
    private _editUrl = APIURL+'Semester/updateSemesterById';
    
    
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
   
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    isSemesterActive(SemesterId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('SemesterId', SemesterId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    getAllSemester():any{
        return this._http.post(this._getSemesterAllUrl,[] )
                            .map((response: Response) => response.json().data)
    }
    getSemestersById(SemestersId:any): any{
         let formData:FormData = new FormData();
         formData.append('SemestersId', SemestersId);
        return this._http.post(this._getSemesterByIdUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getSemesters(userId:any): any{
         let formData:FormData = new FormData();
         formData.append('userId', userId);
        return this._http.post(this._getSemesterUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    getSemestersBySubject(Sub:any):any{
        let formData:FormData = new FormData();
         formData.append('SubjectId', Sub);
        return this._http.post(this._getSemesterBySubUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    
     edit(form:any,isNew,isSubNew):any{ 
         let formData:FormData = new FormData();
         formData.append('SemesterName', form.SemesterName);
         formData.append('SubjectId', form.SubjectId);
         formData.append('UniversityId', form.UniversityId);
         formData.append('isNew', isNew);
         formData.append('isSubNew', isSubNew);
          formData.append('SemesterId', form.SemesterId);
        return this._http.post(this._editUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    add(form:any,isNew,isSubNew):any{ 
         let formData:FormData = new FormData();
         formData.append('SemesterName', form.SemesterName);
         formData.append('SubjectId', form.SubjectId);
         formData.append('UniversityId', form.UniversityId);
         formData.append('isNew', isNew);
         formData.append('isSubNew', isSubNew);
          formData.append('userId', this.currentUser.UserId+"");
        return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    delete(SubjectId): any{
           let formData:FormData = new FormData();
         formData.append('SemesterId',SubjectId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/semester.service.ts